<template>
  <div>
    <!-- Directive -->
    <v-row>
      <v-col cols="4" class="py-0 col-lable">
        <label class="font-weight-bold">
          {{ $t("DIRECTIVE") }}
          <span class="red--text">*</span>
        </label>
      </v-col>
      <v-col class="pa-0">
        <v-textarea
          :spellcheck="false"
          dense
          outlined
          rows="2"
          v-model="formGeneral.leadSentence"
          :error-messages="leadSentenceErrors"
          @input="$v.formGeneral.leadSentence.$touch()"
          @blur="$v.formGeneral.leadSentence.$touch()"
        />
      </v-col>
    </v-row>
    <!-- Question -->
    <v-row>
      <v-col cols="4" class="py-0 col-lable">
        <label class="font-weight-bold">
          {{ $t("QUESTION") }}
          <span class="red--text">*</span>
        </label>
      </v-col>
      <v-col class="pa-0">
        <v-row class="ma-0 d-flex justify-center">
          <v-col class="d-inline-flex pa-0">
            <v-textarea
              :spellcheck="false"
              dense
              :auto-grow="true"
              outlined
              rows="1"
              v-model="formGeneral.name1"
            />
          </v-col>
          <v-col class="d-inline-flex py-0 max-width-2">
            <v-textarea
              :spellcheck="false"
              dense
              :auto-grow="true"
              outlined
              rows="1"
              placeholder="先生"
              v-model="formGeneral.kanji"
              :error-messages="kanjiErrors"
              @input="$v.formGeneral.kanji.$touch()"
              @blur="$v.formGeneral.kanji.$touch()"
            />
          </v-col>
          <v-col class="d-inline-flex pa-0">
            <v-textarea
              :spellcheck="false"
              dense
              :auto-grow="true"
              outlined
              rows="1"
              v-model="formGeneral.name2"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Answer -->
    <v-row>
      <v-col cols="4" class="col-lable"></v-col>
      <v-col class="pa-0">
        <v-row>
          <v-col
            cols="6"
            class="py-0"
            v-for="(item, index) in $v.formGeneral.answers.$each.$iter"
            :key="item.id"
          >
            <v-radio-group
              hide-details
              class="mt-5"
              v-model="formGeneral.isAnsewr"
              :mandatory="false"
            >
              <v-text-field
                v-model="item.value.$model"
                :error-messages="answersErrors(item.value)"
                @input="item.value.$touch()"
                :success="item.$model.id == formGeneral.isAnsewr"
                @blur="item.value.$touch()"
                :style="
                  index % 2 == 0 ? 'margin-right:2.4rem' : 'margin-left:2.2rem'
                "
                dense
                outlined
              >
                <template v-slot:prepend>
                  <v-radio :value="item.$model.id"></v-radio>
                </template>
                <template v-slot:label>
                  <h3>
                    {{ item.$model.name }}
                    <span class="red--text">*</span>
                  </h3>
                </template>
              </v-text-field>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "FormKanji",
  mixins: [validationMixin],
  props: ["parent"],
  store: ["formGeneral"],
  data() {
    return {
      format: /[^\u00BF-\u1FFF\u2C00-\uD7FF０-９Ａ-Ｚａ-ｚ_＿/／\s\w]/g,
    };
  },
  mounted() {
    let update = this.$route.name.search("Update");
    if (update == -1) {
      this.formGeneral.leadSentence =
        "＿の ことばは ひらがなで どう よみますか。\nいちばん いいものを ひとつ えらんでください。";
    }
  },
  validations() {
    return {
      formGeneral: {
        answers: {
          required,
          $each: {
            value: {
              required,
              strongAnswers(answers) {
                return !this.format.test(answers); // checks for special char
              },
            },
          },
        },
        leadSentence: { required },
        kanji: { required },
      },
    };
  },
  computed: {
    leadSentenceErrors() {
      const errors = [];
      if (!this.$v.formGeneral.leadSentence.$dirty) return errors;
      !this.$v.formGeneral.leadSentence.required &&
        errors.push("指示文を入力してください。");
      return errors;
    },
    kanjiErrors() {
      const errors = [];
      if (!this.$v.formGeneral.kanji.$dirty) return errors;
      !this.$v.formGeneral.kanji.required &&
        errors.push("問題文を入力してください。");
      return errors;
    },
  },
  methods: {
    async getParams() {
      this.$v.$touch();
      var params = "";
      if (!this.$v.$anyError) {
        const {
          leadSentence,
          name1,
          name2,
          isAnsewr,
          kanji,
          answers,
        } = this.formGeneral;

        params = {
          sub_key: this.$route.params[this.parent],
          parent: this.parent,
          name: [[name1, kanji, name2]],
          answer1: answers[0].value,
          answer2: answers[1].value,
          answer3: answers[2].value,
          answer4: answers[3].value,
          lead_sentence: leadSentence,
          audio: "",
          script: "",
          image: "",
          answer_correct: [isAnsewr],
          sub_question: {
            question1: {
              answers: [
                {
                  id: 1,
                  name: "回答1",
                  value: "",
                },
                {
                  id: 2,
                  name: "回答2",
                  value: "",
                },
                {
                  id: 3,
                  name: "回答3",
                  value: "",
                },
                {
                  id: 4,
                  name: "回答4",
                  value: "",
                },
              ],
              audio: null,
              isAnsewr: 1,
              script: "",
            },
            question2: {
              answers: [
                {
                  id: 1,
                  name: "回答1",
                  value: "",
                },
                {
                  id: 2,
                  name: "回答2",
                  value: "",
                },
                {
                  id: 3,
                  name: "回答3",
                  value: "",
                },
                {
                  id: 4,
                  name: "回答4",
                  value: "",
                },
              ],
              audio: null,
              isAnsewr: 1,
              script: "",
            },
          },
          list_answer: {
            sentence_answer: [],
            answer: [],
          },
        };
      }
      return params;
    },
    answersErrors(value) {
      if (value.$dirty && !value.required) return "回答を入力してください。";
      if (value.$dirty && !value.strongAnswers) {
        return "特殊文字以外を入力してください。";
      }
    },
  },
};
</script>